// Update header cart icon
window.addEventListener('cart:updated', function(event) {
    console.log("Updating header icon", event.detail);

    const cartCountElement = document.querySelector('.site-header-cart--count');

    if (cartCountElement) {
        const newCartCount = event.detail?.item_count || 0; // Ensure detail exists
        cartCountElement.setAttribute('data-header-cart-count', newCartCount);

        // Optionally show/hide based on count
        if (newCartCount > 0) {
            cartCountElement.classList.add('visible');
        } else {
            cartCountElement.classList.remove('visible');
        }
    }
});


document.addEventListener("DOMContentLoaded", function () {
  // Add to Cart button emits "cart:updated"
  var atcButton = document.getElementById("product-add-to-cart");
  if (atcButton) {
    atcButton.addEventListener("click", function (event) {
      var cartUpdatedEvent = new CustomEvent("cart:updated");
      window.dispatchEvent(cartUpdatedEvent);
      console.log('Emitted "cart:updated" event from ATC button');
      var openSideBarEvent = new CustomEvent("sidebar:open");
      window.dispatchEvent(openSideBarEvent);
      console.log("Emitted sidebar:open from ATC button");
    });
  }

  // For quantity inputs outside of cart-sidebar
  var quantityInputs = document.querySelectorAll(
    "[data-quantity-input]:not(#cart-sidebar [data-quantity-input])"
  );
  quantityInputs.forEach(function (input) {
    input.addEventListener("change", function () {
      var cartUpdatedEvent = new CustomEvent("cart:updated");
      window.dispatchEvent(cartUpdatedEvent);
      console.log('Emitted "cart:updated" event from quantity input change');
    });
  });

  // For plus buttons outside of cart-sidebar
  var plusButtons = document.querySelectorAll(
    "[data-quantity-plus]:not(#cart-sidebar [data-quantity-plus])"
  );
  plusButtons.forEach(function (btn) {
    btn.addEventListener("click", function (event) {
      var cartUpdatedEvent = new CustomEvent("cart:updated");
      window.dispatchEvent(cartUpdatedEvent);
      console.log('Emitted "cart:updated" event from plus button');
    });
  });

  // For minus buttons outside of cart-sidebar
  var minusButtons = document.querySelectorAll(
    "[data-quantity-minus]:not(#cart-sidebar [data-quantity-minus])"
  );
  minusButtons.forEach(function (btn) {
    btn.addEventListener("click", function (event) {
      var cartUpdatedEvent = new CustomEvent("cart:updated");
      window.dispatchEvent(cartUpdatedEvent);
      console.log('Emitted "cart:updated" event from minus button');
    });
  });
});
